// extracted by mini-css-extract-plugin
export default {"toggle-switch":"toggleSwitch_toggle-switch","switch":"toggleSwitch_switch"};